import { observer } from 'mobx-react';
import Loader from '../../../../../../Loader';
import BrowseAllExperiences from '../../../../CurrentCollectionStep/Builder/BrowseAllExperiences';
import LearningDesignExperiences from '../../../../CurrentCollectionStep/Builder/LearningDesignExperiences';
import LearningCollectionEditStore from '../../../Store';
import { CustomizeState } from '../../../Store/Types';
import LearningDesignBrowseAllExperiences from '../../../../CurrentCollectionStep/Builder/LearningDesignBrowseAllExperiences';

interface Props {
  store: LearningCollectionEditStore;
  state: CustomizeState;
}

function ProgramsState({ store, state }: Props) {
  switch (state.kind) {
    case 'updating-product-license':
      return <Loader className="h-40" />;
    case 'building':
    case 'edit-form-submission-error':
    case 'adding-learning-design':
      return (
        <>
          <LearningDesignExperiences
            store={store}
            state={state}
            learningCollectionEditFormResource={state.learningCollectionEditFormResource}
          />
          <BrowseAllExperiences store={store} />
          <LearningDesignBrowseAllExperiences
            store={store}
            state={state}
            learningCollectionEditFormResource={state.learningCollectionEditFormResource}
          />
        </>
      );
  }
}

export default observer(ProgramsState);
